const FONT_WEIGHT_MAP = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};
const getFontWeightValue = (weight) => FONT_WEIGHT_MAP[weight] ?? 400;
function buildPromptInputStyles(p) {
  return `
    .concierge-prompt-input [data-slot="input-group"] {
      border: none !important;
      box-shadow: none !important;
      --tw-shadow: 0 0 #0000 !important;
      --tw-shadow-colored: 0 0 #0000 !important;
      background: transparent !important;
      padding: 0 !important;
      margin: 0 !important;
      min-height: 0 !important;
      height: auto !important;
      outline: none !important;
    }
    .concierge-prompt-input [data-slot="input-group"]:has([data-slot="input-group-control"]:focus-visible) {
      --tw-ring-color: transparent !important;
      --tw-ring-offset-width: 0 !important;
      --tw-ring-width: 0 !important;
      box-shadow: none !important;
    }
    .concierge-prompt-input [data-slot="input-group-control"]:focus-visible {
      outline: none !important;
      --tw-ring-color: transparent !important;
      box-shadow: none !important;
    }
    .concierge-prompt-input textarea,
    .concierge-prompt-input textarea:focus,
    .concierge-prompt-input textarea:focus-visible {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      --tw-shadow: 0 0 #0000 !important;
      --tw-shadow-colored: 0 0 #0000 !important;
    }
    .concierge-prompt-input:focus-within {
      border-color: ${p.focusBorderColor} !important;
    }
    .concierge-prompt-input textarea {
      font-size: ${p.fontSize}px !important;
      font-weight: ${getFontWeightValue(p.fontWeight)} !important;
      font-family: ${p.fontFamilyCss} !important;
      color: ${p.textColor} !important;
    }
    .concierge-prompt-input textarea::placeholder {
      color: ${p.placeholderColor} !important;
    }
    .concierge-prompt-input [data-concierge-submit]:not(:disabled) {
      background-color: ${p.submitBgColor} !important;
    }
    .concierge-prompt-input [data-concierge-submit]:hover:not(:disabled) {
      background-color: ${p.submitBgColorHover} !important;
    }
    .concierge-prompt-input [data-concierge-submit]:disabled {
      opacity: 0.5 !important;
    }
    @media (max-width: 767px) {
      .concierge-prompt-input textarea {
        font-size: ${p.mobileFontSize}px !important;
        padding-top: ${p.mobilePaddingY}px !important;
        padding-bottom: ${p.mobilePaddingY}px !important;
        padding-left: ${p.mobilePaddingX}px !important;
        min-height: ${p.mobileMinHeight > 0 ? `${p.mobileMinHeight}px` : "0"} !important;
      }
      .concierge-prompt-input-icons {
        padding-right: ${p.mobilePaddingX}px !important;
        padding-left: ${p.mobilePaddingX}px !important;
        padding-bottom: ${p.mobilePaddingY}px !important;
      }
    }
  `;
}
export {
  buildPromptInputStyles,
  getFontWeightValue
};
//# sourceMappingURL=styles.js.map
